import { ValueOf } from '../../../../../../shared/type/util.type.ts';

export const ProductType = {
  ALWAYS: 'ALWAYS',
  HAND_MADE: 'HAND_MADE',
} as const;
export type ProductType = ValueOf<typeof ProductType>;

export const StockType = {
  TOTAL_STOCK: 'TOTAL_STOCK',
  OPTION_STOCK: 'OPTION_STOCK',
} as const;
export type StockType = ValueOf<typeof StockType>;

export const PRODUCT_PRICE__MIN = 1_000;
export const PRODUCT_PRICE__MAX = 10_000_000;
export const MAX_PURCHASE_PER_USER__MAX = 1_000;
export const SPO_OPTIONS__MAX = 3;
export const SPO_ITEMS__MAX = 1_000;
export const SPO_OPTION_VALUES__MIN = 1;
export const SPO_OPTION_VALUES__MAX = 20;
export const SPO_ITEM_STOCK__MAX = 9_999_999;
export const SPO_TEXT_OPTION__MAX = 100;

const SPO_DEFAULT_TEXT_OPTION = { id: '', name: '' };
const SPO_DEFAULT_TEXT_OPTION_INTL = { id: '', name: '', name_en: '', name_jp: '' };

const SPO_DEFAULT_BASE = {
  stock_type: StockType.TOTAL_STOCK,
  _: {
    spo_options: [],
    spo_items: [],
  },
};

export const SPO_DEFAULT = {
  ...SPO_DEFAULT_BASE,
  _: {
    ...SPO_DEFAULT_BASE._,
    spo_text_options: [SPO_DEFAULT_TEXT_OPTION],
  },
};

export const SPO_DEFAULT_INTL = {
  ...SPO_DEFAULT_BASE,
  _: {
    ...SPO_DEFAULT_BASE._,
    spo_text_options: [SPO_DEFAULT_TEXT_OPTION_INTL],
  },
};
